/**
 * Channel "handle" — the account identifier used in a channel's social URL
 * (e.g. instagram.com/itshelenmelon → "itshelenmelon"). This is what admins
 * search a channel by, so we surface it next to the channel name.
 *
 * Mirrors the v1 `User.getUsername()` logic (gc-mono models/User.js): prefer the
 * crawled `raw.username`, otherwise derive the identifier from the channel URL.
 */

import { detectSite, extractId } from './socialUrl';

interface HandleChannel {
  url?: string | null;
  raw?: { username?: unknown } | null;
}

export function getChannelHandle(channel: HandleChannel | null | undefined): string | null {
  const rawUsername = channel?.raw?.username;
  if (typeof rawUsername === 'string' && rawUsername.trim()) return rawUsername;

  const url = channel?.url;
  if (!url) return null;
  const site = detectSite(url);
  if (!site) return null;
  const { id, type } = extractId(site, url);
  // A YouTube /channel/UC… id is an internal channel id, not a handle — skip it.
  if (type === 'channel') return null;
  return id;
}
